import { useGetCatalogResourcesQuery } from '../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService.hooks';
export const useCatalogResources = (requestedResources, skip) => {
  const {
    loading,
    error,
    data
  } = useGetCatalogResourcesQuery({
    variables: {
      requestedResources
    },
    skip: skip || !requestedResources.length
  });
  return {
    resources: data === null || data === void 0 ? void 0 : data.results,
    loading,
    error
  };
};